import type { FaireProductEntity } from "../../entity_types/product";

export const p_znh8thcmbp: FaireProductEntity = {
  token: "p_znh8thcmbp",
  type: "product",
  name: "Les Anis de Flavigny Lemon, Rose, Orange Blossom 3 x 1.8oz",
  brandToken: "b_9anqzdvs32",
  brandName: "The French Farm",
  imageUrl: "https://cdn.faire.com/fastly/b210d5e20e2899814764df252701222b7a7c6222f5d34cad744da7f800ed5147.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.65,
  description: "Treat yourself or someone you love to a delicious and elegant gift with this 3-Tin Gift Set of Lemon, Orange Blossom, and Rose Candies. Each tin contains a variety of hard candies with a center of aniseed, coated in fine layers of sugar and all-natural flavoring. The flavors are bright and refreshing, and the aniseed adds a subtle, licorice-like note. The candies are perfect for sampling, and they make a thoughtful and unique gift for any occasion. Ingredients: Sugar, Natural Flavoring, Green Aniseed",
  tags: [],
  msrpDollars: 27.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:55.402Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
